import { call, put, select, takeLeading } from 'redux-saga/effects'
import {
  types,
  IGetCapabilitiesSummaryAction,
  ICapabilitiesSummary,
  ICapabilitiesSummaryRaw,
} from '../types/capabilitiesSummary'
import * as actions from '../actions/capabilitiesSummary'
import { trace } from '../services/common'
import { getGroupCapabilitiesSummary } from '../services/groups'
import { selectCapabilitiesSummaryPerGroup } from '../selectors/capabilitiesSummary'

export function* getCapabilitiesSummarySaga(
  action: IGetCapabilitiesSummaryAction
) {
  try {
    const selectedGroupCapabilities: ICapabilitiesSummary = yield select(
      selectCapabilitiesSummaryPerGroup(action.groupId)
    )
    if (!selectedGroupCapabilities) {
      const { mediaTypes, ...restData }: ICapabilitiesSummaryRaw = yield call(
        getGroupCapabilitiesSummary,
        action.groupId
      )
      yield put(
        actions.getCapabilitiesSummarySuccess(action.groupId, {
          ...restData,
          allowedExtensions: mediaTypes.map(({ extension }) => extension),
        })
      )
    } else {
      yield put(actions.getCapabilitiesSummaryCancel())
    }
  } catch (err) {
    trace(err)
    yield put(actions.getCapabilitiesSummaryFailure(err.message))
  }
}

export function* capabilitiesSummaryWatcher() {
  yield takeLeading(
    types.GET_CAPABILITIES_SUMMARY__START,
    getCapabilitiesSummarySaga
  )
}
